module.exports = __webpack_public_path__ + "img/tip.d34ed289.png";